export default {
  new_document: "Novo documento",
  update_document: "Atualizar documento - {code}",
};
